module.exports = __webpack_public_path__ + "static/img/47.b4ac667a.gif";